import React, { useState, useEffect, useRef } from 'react';
import axios from '../../Axios';
import styles from './HeaderMobile.module.css';
import Logo from '../../Content/images/logo3.png';
import { withRouter, NavLink, useHistory } from 'react-router-dom';
import './../Payment/Checkout.css';
import PopupModal from '../Shared/PopupModal/PopupModal';
import { Activity, currentRequestTimeStamp, RoutePaths } from '../../Constants';
import { PROCURE_URLS, DC_URL, Urls } from '../../Urls';
import ParametersMapForm from '../MyAccount/GeneratePPT/PPTGenerate/PPTGenerate';
import mixpanel from 'mixpanel-browser';
import { logout, auth } from "../firebase/firebase";
import useViewOnlyAccess from '../../hooks/useViewOnlyAccess';

// click-outside helper (replaces ClickOutSide)
function useOnClickOutside(ref, handler) {
  useEffect(() => {
    const listener = (e) => {
      if (!ref.current || ref.current.contains(e.target)) return;
      handler(e);
    };
    document.addEventListener('mousedown', listener);
    document.addEventListener('touchstart', listener);
    return () => {
      document.removeEventListener('mousedown', listener);
      document.removeEventListener('touchstart', listener);
    };
  }, [ref, handler]);
}

const HeaderMobile = ({ userDetails,isUserinTeams }) => {
  const history = useHistory();
  const [allowedTrackingDashboard, setAllowedTrackingDashboard] = useState("no")
  const [user, setUser] = useState();
  const [isAllowed, setIsAllowed] = useState('no');
  const [DiscoverNowallowed, setDiscoverNowallowed] = useState('no');
  const [BenchmarkNowAllowed, setBenchmarkNowAllowed] = useState('no');
  const [CompareNow, setCompareNow] = useState('no');
  const [indent, setIndent] = useState('no');
  const [invoice, setInvoice] = useState('no');
  const [gigo, setGigo] = useState('no');
  const [HomeSearch, setHomeSearch] = useState('no');
  const [ProcureNow, setProcureNow] = useState('no');
  const [ContractNow, setContractNow] = useState('no');
  const [SynergyNow, setSynergyNow] = useState('no');
  const [unreadMessages, setunreadMessages] = useState(0);
  const [Ppt, setPpt] = useState('no');
  const [RFQCalender, setRFQCalender] = useState('yes');
  const [planning, setPlanning] = useState('yes');

  // NEW: React-driven UI (no Bootstrap JS)
  const [isNavOpen, setIsNavOpen] = useState(false);         // mobile hamburger
  const [openMenu, setOpenMenu] = useState(null);            // 'transporters' | 'services' | 'operations' | 'profile' | null
  const [showProfilePopUp, setShowProfilePopUp] = useState(false);

  const transportersRef = useRef(null);
  const servicesRef = useRef(null);
  const operationsRef = useRef(null);
  const profileRef = useRef(null);
  const { hasModuleAccess: planningModuleAccess, noAccess: planningNoAccess } = useViewOnlyAccess('planning');
  const { hasModuleAccess: spotModuleAccess, noAccess: spotNoAccess } = useViewOnlyAccess('spot');
  const { hasModuleAccess: reqAccess, noAccess: reqNoAccess } = useViewOnlyAccess('indent', 'lorri_indent_request');
  const { hasModuleAccess: trackAccess, noAccess: trackNoAccess } = useViewOnlyAccess('indent', 'lorri_indent_tracking');
  const { noAccess: invoiceNoAccess } = useViewOnlyAccess('invoice');

  useOnClickOutside(transportersRef, () => openMenu === 'transporters' && setOpenMenu(null));
  useOnClickOutside(servicesRef, () => openMenu === 'services' && setOpenMenu(null));
  useOnClickOutside(operationsRef, () => openMenu === 'operations' && setOpenMenu(null));
  useOnClickOutside(profileRef, () => showProfilePopUp && setShowProfilePopUp(false));

  const toggleMenu = (key) => setOpenMenu(prev => (prev === key ? null : key));

  useEffect(() => {
    getCurrentUser();

    const setPolicyAllowed = (policy, setter) => setter(policy?.allowed ? policy.allowed : 'no');
    const userPolicy = userDetails?.policy || {};

    const anyTrackingAllowed = (userPolicy?.indents?.allowed_sim_tracking === "yes" || userPolicy?.indents?.track_and_trace?.allowed==="yes") ? true : false

    // tracking dashboard access with any one of fastag or sim.
    setAllowedTrackingDashboard((userPolicy && userPolicy?.indents && userPolicy?.indents?.allow_lorri_tracking_dashboard && userPolicy?.indents?.allow_lorri_tracking_dashboard === "yes") && (anyTrackingAllowed) ? "yes" : "no")


    setPolicyAllowed(userPolicy?.data_cleaning, setIsAllowed);
    setPolicyAllowed(userPolicy?.discovernow, setDiscoverNowallowed);
    setPolicyAllowed(userPolicy?.benchmarknow, setBenchmarkNowAllowed);
    setPolicyAllowed(userPolicy?.indents, setIndent);
    setPolicyAllowed(userPolicy?.gatein_gateout, setGigo);
    setPolicyAllowed(userPolicy?.invoice, setInvoice);
    setPolicyAllowed(userPolicy?.comparenow, setCompareNow);
    setPolicyAllowed(userPolicy?.home_search, setHomeSearch);
    setPolicyAllowed(userPolicy?.procurement, setProcureNow);
    setPolicyAllowed(userPolicy?.contractnow, setContractNow);
    setPolicyAllowed(userPolicy?.synergynow, setSynergyNow);
    setPolicyAllowed(userPolicy?.ppt, setPpt);
    setPolicyAllowed(userPolicy?.rfq_calender, setRFQCalender);
    setPolicyAllowed(userPolicy?.planning, setPlanning);
  }, [userDetails]);

  const getCurrentUser = () => {
    axios.get(Urls.Users.GetCurrentUser)
      .then(res => {
        if (res.data && res.data.user_details) {
          setUser(res.data.user_details);
          localStorage.setItem('userdetails', res.data.user_details.name);
          localStorage.setItem('useremail', res.data.user_details.emails[0]);
        }
      })
      .catch(console.log);
  };

  const Logmeout = async () => {
    mixpanel.track(`User has clicked on logout`, {
      ApplicationName: `${Urls.mixpanelappname}`,
      ScreenName: 'LoRRI-Header',
      ModuleName: 'landing_page',
      ActivityLog: 'userClickedLogOut',
      Data: `None`,
      Definition: `User has clicked on logout`,
      ActivityType: 'event_view',
      UserName: `${localStorage.getItem("userdetails")}`,
      UserEmail: `${localStorage.getItem("useremail")}`,
      CompanyName: `${localStorage.getItem("companyname")}`
    });
    sessionStorage.removeItem("accessToken");
    localStorage.removeItem("user_name");
    if (logout(auth)) {
      history.push(RoutePaths.Login); // replace <Redirect />
    }
  };

  const myAccountClicked = () => {
    mixpanel.track(`User has clicked on my account button`, {
      ApplicationName: `${Urls.mixpanelappname}`,
      ScreenName: 'LoRRI-Header',
      ModuleName: 'my_account',
      ActivityLog: 'userClickedMyAccount',
      Data: `None`,
      Definition: `User has clicked on my account button`,
      ActivityType: 'event_view',
      UserName: `${localStorage.getItem("userdetails")}`,
      UserEmail: `${localStorage.getItem("useremail")}`,
      CompanyName: `${localStorage.getItem("companyname")}`
    });
  };

  const siteMap = () => {
    mixpanel.track(`User has clicked on Sitemap button`, {
      ApplicationName: `${Urls.mixpanelappname}`,
      ScreenName: 'LoRRI-Header',
      ModuleName: 'my_account',
      ActivityLog: 'userClickedMyAccount',
      Data: `None`,
      Definition: `User has clicked on my account button`,
      ActivityType: 'event_view',
      UserName: `${localStorage.getItem("userdetails")}`,
      UserEmail: `${localStorage.getItem("useremail")}`,
      CompanyName: `${localStorage.getItem("companyname")}`
    });
  };

  const changePassword = async () => {
    mixpanel.track(`User has clicked on change password button`, {
      ApplicationName: `${Urls.mixpanelappname}`,
      ScreenName: 'LoRRI-Header',
      ModuleName: 'landing_page',
      ActivityLog: 'userClickedChangePassword',
      Data: `None`,
      Definition: `User has clicked on change password button`,
      ActivityType: 'event_view',
      UserName: `${localStorage.getItem("userdetails")}`,
      UserEmail: `${localStorage.getItem("useremail")}`,
      CompanyName: `${localStorage.getItem("companyname")}`
    });
    // your old code tried to logout then redirect to forgot-password; keep intent:
    if (logout(auth)) {
      history.push(RoutePaths.ForgotPassword);
    }
  };

  const UserProfile = ({ user }) => {
    const displayName = (user && user.name) || localStorage.getItem('user_name') || '';
    return (
      <div className={styles.profileSection} ref={profileRef}>
        <button
          id="user_button"
          className={styles.profileBtn}
          onClick={() => setShowProfilePopUp(prev => !prev)}
        >
          <span className={styles.avatar}>{displayName.charAt(0).toUpperCase()}</span>
          <span className={styles.profileName}>{displayName}</span>
          <i className={`fas fa-chevron-down ${styles.profileChevron}`} />
        </button>

        {showProfilePopUp ? <UserProfilePopUp /> : null}
      </div>
    );
  };

  const UserProfilePopUp = () => {
    return (
      <div className={styles.profilePopup}>
        <ul className={styles.popupList}>
          <li className={styles.popupItem}>
            <NavLink
              className={styles.popupLink}
              to={RoutePaths.MyAccount}
              rel="noopener noreferrer"
              id="my_account_link"
              onClick={() => { myAccountClicked(); setShowProfilePopUp(false); }}
            >
              My Account
            </NavLink>
          </li>

          <li className={styles.popupItem}>
            <NavLink
              className={styles.popupLink}
              to={RoutePaths.Sitemap}
              rel="noopener noreferrer"
              id="my_account_link"
              onClick={() => { siteMap(); setShowProfilePopUp(false); }}
            >
              Site Map
            </NavLink>
          </li>

          <li className={styles.popupItem}>
            <NavLink
              to={RoutePaths.CompanyProfile}
              className={styles.popupLink}
              id="my_account_link"
              onClick={() => setShowProfilePopUp(false)}
            >
              My Company Profile
            </NavLink>
          </li>

          <li className={styles.popupItem}>
            <NavLink
              to={RoutePaths.Billing}
              className={styles.popupLink}
              id="my_account_link"
              onClick={() => setShowProfilePopUp(false)}
            >
              Billing and Payments
            </NavLink>
          </li>

          <li className={styles.popupItem}>
            <NavLink
              to={RoutePaths.LorriMail}
              onClick={() => {
                mixpanel.track(`User has clicked on lorri mail`, {
                  ApplicationName: `${Urls.mixpanelappname}`,
                  ScreenName: 'LoRRI-Header',
                  ModuleName: 'lorri_mail',
                  ActivityLog: `userClickedLorriMail`,
                  Data: `None`,
                  Definition: `User has clicked on lorri mail`,
                  ActivityType: 'event_view',
                  UserName: `${localStorage.getItem("userdetails")}`,
                  UserEmail: `${localStorage.getItem("useremail")}`,
                  CompanyName: `${localStorage.getItem("companyname")}`
                });
                setShowProfilePopUp(false);
              }}
              className={styles.popupLink}
              id="lorri_inmail_link"
            >
              LoRRI-Mail {unreadMessages > 0 ? `(${unreadMessages})` : ''}
            </NavLink>
          </li>

          <li className={styles.popupItem}>
            <button
              className={styles.popupLink}
              id="change_password_link"
              onClick={() => { setShowProfilePopUp(false); changePassword(); }}
            >
              Change Password
            </button>
          </li>

          <hr className={styles.popupDivider} />

          <li className={styles.popupItem}>
            <button
              className={styles.popupLink}
              onClick={() => { setShowProfilePopUp(false); Logmeout(); }}
              id="logout_link"
            >
              <span className={styles.popupLogout}>
                <i className="fas fa-power-off" />&nbsp; Logout
              </span>
            </button>
          </li>
        </ul>
      </div>
    );
  };

  return (
    <nav className={styles.navbar}>
      <NavLink to='/myTransporters' className={styles.logoArea}>
        {/* <i className={`fas fa-truck ${styles.logoIcon}`} />
        <span className={styles.logoText}>LoRRI</span> */}
        <img
          src={Urls.LorriLogoLogin}
          title='Lorri Logo'
          width={95}
          alt='logo'
        />
      </NavLink>

      <div className={styles.topbarRight}>
        <button
          id="hamburger"
          className={styles.hamburger}
          type="button"
          aria-controls="navbarSupportedContent"
          aria-expanded={isNavOpen}
          aria-label="Toggle navigation"
          onClick={() => setIsNavOpen(s => !s)}
        >
          <i className="fas fa-bars" />
        </button>
        <UserProfile user={user} />
      </div>

      <div
        className={`${styles.navMenu} ${isNavOpen ? styles.navMenuOpen : ''}`}
        id="navbarSupportedContent"
      >
        <ul className={styles.navList}>
          {BenchmarkNowAllowed === 'yes' ? (
            <li className={styles.navItem}>
              <NavLink className={styles.navLink} to={RoutePaths.BenchmarkNow} onClick={() => setIsNavOpen(false)}>
                LoRRI Benchmark
              </NavLink>
            </li>
          ) : null}

          {ProcureNow === 'yes' ? (
            <li className={styles.navItem} id="navbarDropdown_benchmark">
              <a
                className={styles.navLink}
                id='procure_procurenow'
                href={isUserinTeams ? PROCURE_URLS.LOGIN(sessionStorage.getItem('uid')) : undefined}
                target="_self"
                rel="noopener noreferrer"
                onClick={() => setIsNavOpen(false)}
              >
                LoRRI Procure
              </a>
            </li>
          ) : null}

          {/* TRANSPORTER DROPDOWN */}
          <li className={styles.navItem} id="my_transporters" ref={transportersRef}>
            <button
              className={styles.dropdownToggle}
              id="navbarDropdown_transporters"
              aria-haspopup="true"
              aria-expanded={openMenu === 'transporters'}
              onClick={() => toggleMenu('transporters')}
            >
              Transporter <i className="fas fa-chevron-down" />
            </button>
            <div
              className={`${styles.dropdownMenu} ${openMenu === 'transporters' ? styles.dropdownMenuShow : ''}`}
              aria-labelledby="navbarDropdown_transporters"
            >
              <NavLink className={styles.dropdownItem} to={RoutePaths.MyTransporters}
                onClick={() => { setOpenMenu(null); setIsNavOpen(false); }}>
                RateNow
              </NavLink>
              {DiscoverNowallowed === 'yes' ? (
                <NavLink className={styles.dropdownItem} to={RoutePaths.DiscoverNow}
                  onClick={() => { setOpenMenu(null); setIsNavOpen(false); }}>
                  DiscoverNow
                </NavLink>
              ) : null}
              {CompareNow === 'yes' ? (
                <NavLink className={styles.dropdownItem} to={RoutePaths.CompareNow}
                  onClick={() => { setOpenMenu(null); setIsNavOpen(false); }}>
                  CompareNow
                </NavLink>
              ) : null}
              {ContractNow === 'yes' ? (
                <NavLink className={styles.dropdownItem} to={RoutePaths.ContractNow}
                  onClick={() => { setOpenMenu(null); setIsNavOpen(false); }}>
                  ContractNow
                </NavLink>
              ) : null}
              {HomeSearch === 'yes' ? (
                <NavLink className={styles.dropdownItem} to={RoutePaths.SearchTransportersMobile}
                  onClick={() => { setOpenMenu(null); setIsNavOpen(false); }}>
                  Search Transporters
                </NavLink>
              ) : null}
            </div>
          </li>

          {/* ANALYTICS DROPDOWN */}
          {(SynergyNow === 'yes' || Ppt === 'yes' || isAllowed === "yes" || RFQCalender === 'yes') ? (
            <li className={styles.navItem} id="services" ref={servicesRef}>
              <button
                className={styles.dropdownToggle}
                id="navbarDropdown_services"
                aria-haspopup="true"
                aria-expanded={openMenu === 'services'}
                onClick={() => toggleMenu('services')}
              >
                Analytics <i className="fas fa-chevron-down" />
              </button>
              <div
                className={`${styles.dropdownMenu} ${openMenu === 'services' ? styles.dropdownMenuShow : ''}`}
                aria-labelledby="navbarDropdown_services"
              >
                {SynergyNow === 'yes' ? (
                  <NavLink className={styles.dropdownItem} to={RoutePaths.SynergyNow}
                    onClick={() => { setOpenMenu(null); setIsNavOpen(false); }}>
                    Strategic Services
                  </NavLink>
                ) : null}
                {Ppt === 'yes' ? (
                  <PopupModal
                    buttonLabel={"AnalyticsPPT"}
                    style={{ color: "rgb(46, 49, 146)", textDecoration: "none", textAlign: "left", width: "100%" }}
                    buttonClass="contact_us_button btn btn-light"
                    content={<ParametersMapForm />}
                    id={"PPT_Generation_Wizard"}
                    title={`PPT Generation Wizard`}
                  />
                ) : null}
                {RFQCalender === 'yes' ? (
                  <NavLink className={styles.dropdownItem} to={RoutePaths.RFQCalender}
                    onClick={() => { setOpenMenu(null); setIsNavOpen(false); }}>
                    RFQ Calender
                  </NavLink>
                ) : null}
                {isAllowed === "yes" ? (
                  <a
                    className={styles.dropdownItem}
                    href={DC_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={() => { setOpenMenu(null); setIsNavOpen(false); }}
                  >
                    My Data
                  </a>
                ) : null}
              </div>
            </li>
          ) : null}

          {(spotNoAccess ? spotModuleAccess : true) ? (
            <li className={styles.navItem}>
              <NavLink className={styles.navLink} to={RoutePaths.SpotDashboard} onClick={() => setIsNavOpen(false)}>
                LoRRI Spot
              </NavLink>
            </li>
          ) : null}

          <li className={styles.navItem}>
            <NavLink className={styles.navLink} to={RoutePaths.LocationDashboard} onClick={() => setIsNavOpen(false)}>
              Location Dashboard
            </NavLink>
          </li>

          {/* OPERATIONS DROPDOWN */}
          <li className={styles.navItem} id="operations_button" ref={operationsRef}>
            <button
              className={styles.dropdownToggle}
              id="navbarDropdown_operations"
              aria-haspopup="true"
              aria-expanded={openMenu === 'operations'}
              onClick={() => toggleMenu('operations')}
            >
              Operations <i className="fas fa-chevron-down" />
            </button>
            <div
              className={`${styles.dropdownMenu} ${openMenu === 'operations' ? styles.dropdownMenuShow : ''}`}
              aria-labelledby="navbarDropdown_operations"
            >
              {((reqNoAccess ? reqAccess : true) || (trackNoAccess ? trackAccess : true)) && indent === 'yes' ? (
                <NavLink className={styles.dropdownItem} to={RoutePaths.IndentRequestMobile} exact
                  onClick={() => { setOpenMenu(null); setIsNavOpen(false); }}>
                  Indent
                </NavLink>
              ) : null}
              {allowedTrackingDashboard === 'yes' ? (
                <NavLink className={styles.dropdownItem} to={RoutePaths.TrackingDashboard} exact
                  onClick={() => { setOpenMenu(null); setIsNavOpen(false); }}>
                  LoRRI Tracking
                </NavLink>
              ) : null}
              {gigo === 'yes' ? (
                <NavLink className={styles.dropdownItem} to={RoutePaths.GigoGateIn} exact
                  onClick={() => { setOpenMenu(null); setIsNavOpen(false); }}>
                  Gate-In &amp; Gate-Out
                </NavLink>
              ) : null}
              {!invoiceNoAccess && invoice === 'yes' ? (
                <NavLink className={styles.dropdownItem} to={RoutePaths.Invoice} exact
                  onClick={() => { setOpenMenu(null); setIsNavOpen(false); }}>
                  LoRRI Invoice
                </NavLink>
              ) : null}
              {(planningNoAccess ? planningModuleAccess : planning === 'yes') ? (
                <NavLink className={styles.dropdownItem} to={RoutePaths.PlanningDashboard} exact
                  onClick={() => { setOpenMenu(null); setIsNavOpen(false); }}>
                  LoRRI Planning
                </NavLink>
              ) : null}
            </div>
          </li>
        </ul>

        <div className={styles.dashboardArea}>
          <NavLink
            className="btn btn-sm btn-primary"
            to={RoutePaths.Dashboard}
            onClick={() => {
              Activity([{
                screen: "Header", module: "LoRRI Dashboard", user_activity: "LoRRI Dashboard Button clicked on header", timestamp: currentRequestTimeStamp()
              }]);
              mixpanel.track(`User has clicked on lorri dashboard`, {
                ApplicationName: `${Urls.mixpanelappname}`,
                ScreenName: 'LoRRI-Header',
                ModuleName: 'lorri_dashboard',
                ActivityLog: 'userClickedLorriDashboard',
                Data: `None`,
                Definition: `User has clicked on lorri dashboard`,
                ActivityType: 'event_view',
                UserName: `${localStorage.getItem("userdetails")}`,
                UserEmail: `${localStorage.getItem("useremail")}`,
                CompanyName: `${localStorage.getItem("companyname")}`
              });
              setIsNavOpen(false);
            }}
          >
            LoRRI Dashboard
          </NavLink>
        </div>
      </div>
    </nav>
  );
};

export default withRouter(HeaderMobile);
